import { Component, Output, EventEmitter, OnInit, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

import { Lesson } from '../../../@core/models/lesson';

import { GeneralService } from '../../../@core/data/general.service';
import { TimelineService } from '../../../@core/data/timeline.service';
import { LoginService } from '../../../@core/data/login.service';

@Component({
  selector: 'edm-html-viewer',
  templateUrl: './html-viewer.component.html',
  styleUrls: ['./html-viewer.component.scss'],
  standalone: false
})
export class HTMLViewerComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output() progress: EventEmitter<number> = new EventEmitter<number>();
  @Output() pages: EventEmitter<number> = new EventEmitter<number>();

  model: {id: number, content: string, content_is_ai: boolean};
  htmlContent: SafeHtml;
  loaded: boolean = false;

  showInIframe: boolean = false;
  iframeScr: SafeResourceUrl;

  backUrl: string;
  menuHtml!: boolean;
  menuTitle: string;
  private contextMenuListener: () => void;
  private keydownListener: any;

  constructor(
    private modelService: TimelineService,
    private generalService: GeneralService,
    private loginService: LoginService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private http: HttpClient
  ) {
    this.model = this.generalService.get('html_lesson', true);
    this.showInIframe = this.model?.content_is_ai? false : true;
    this.contextMenuListener = this.preventContextMenu.bind(this);
  }

  ngOnInit(): void {
    this.elementRef.nativeElement.addEventListener('contextmenu', this.contextMenuListener);
    this.backUrl = this.router.url.replace('/texto', '');
    let paths: string[] = this.backUrl.split('/');

    if (this.router.url.includes('menuitem')) {
      this.modelService.menu$.subscribe(item=> {
        if (item) {
          this.menuHtml = true;
          this.menuTitle = item.cta_caption;
          this.backUrl = this.router.url.replace('/menuitem', '');
          this.loaded = true;
          this.iframeScr = this.safeUrl(item.action.url);
          if (item.action.type === 'EXTERNAL_URL') {
            this.showInIframe = true;
          } else {
            this.loadHtmlContent(item.action.url);
          }
          return
        }

        this.router.navigate(['/produtos'])

      })
      return
    }

    if (!isNaN(parseInt(paths[(paths.length - 1)])) && !isNaN(parseInt(paths[(paths.length - 2)]))) {
      paths.pop();
      this.backUrl = paths.join('/');
    }
    this.model = this.generalService.get('html_lesson', true);
    this.route.params.subscribe(
      (param: string[]): void => {
        const modelId: number = parseInt(param["lessonId"]);
        if (modelId != this.model.id) this.loadData(modelId);
        else {
          this.iframeScr = this.safeUrl(this.model.content);
          this.loadHtmlContent(this.model.content);
          if (this.loginService.isAuthenticated()) this.modelService.finish(this.model.id).subscribe();
        }
      },
      (): void => {}
    );
  }

  ngAfterViewInit(): void {
    this.protectedPage();
  }

  ngOnDestroy(): void {
    if (this.keydownListener) {
      document.removeEventListener('keydown', this.keydownListener);
    }
  }

  private protectedPage(): void {
    this.keydownListener = (event: KeyboardEvent) => {
      if (event.key === 'a' || event.key === 'c') {
        event.preventDefault();
      }
    };
    document.addEventListener('keydown', this.keydownListener);
  }

  private loadData(modelId: number): void {
    this.modelService.lesson(modelId).subscribe(
      (done: Lesson): void => {
        this.model = {
          id: done.id,
          content: done.html_url,
          content_is_ai: done.content_is_ai,
        };
        this.iframeScr = this.safeUrl(this.model.content);
        this.loadHtmlContent(this.model.content);
        if (this.loginService.isAuthenticated()) this.modelService.finish(this.model.id).subscribe();
        this.generalService.store(this.model, 'html_lesson', true);
      },
      (): void => {
        this.router.navigate(["produtos"]);
      }
    );
  }

  private loadHtmlContent(url: string): void {
    this.http.get(url, { responseType: 'text' }).subscribe(
      (html: string) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const bodyContent = doc.body.innerHTML;
        this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(bodyContent);;
        this.loaded = true;
      },
      () => {
        this.router.navigate(["produtos"]);
      }
    );
  }

  private preventContextMenu(event: Event): void {
    event.preventDefault();
  }

  safeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
